import React, { Fragment } from 'react';

import Header from 'components/UI/Header/Header';
import Footer from 'components/UI/Footer/Footer';
import Sections from 'components/sections/Sections';

import { Redirect } from "react-router-dom";

function LandingPage(props) {

  if (props.loading) {
    return <Redirect to='/search-result' />;
  }

  return (
    <Fragment>
      <Header />
      <main>
        <Sections />
      </main>
      <Footer />
    </Fragment>
  );
}
/*
LandingPage.propTypes = {
  searchProduct: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  loading: state.search.loading,
});
*/
export default LandingPage
